import { ReactElement } from 'react';
import { Box } from '@twilio-paste/core/box';
import { Grid, Column } from '@twilio-paste/core/grid';
import { SkeletonLoader } from '@twilio-paste/core/skeleton-loader';
import { Stack } from '@twilio-paste/core/stack';

import { types } from './definitions';

import ProductCard from '../productCard';
import { dataTestIds } from '@twiliointernal/org/twilio/e2-commons/shared/definitions';

const ProductCardLoaders = ({
  articlesCount = 3,
  cardContainerClassName,
  cardsCount = 6,
  icon,
  productCardHeight,
}: types.ProductCardLoadersProps): ReactElement => {
  const productCardLoadersCount = new Array(cardsCount).fill(null);
  const articlesLoadersCount = new Array(articlesCount).fill(null);

  return (
    <Grid
      data-testid={dataTestIds.productCard.loaders}
      equalColumnHeights
      gutter="space50"
      vertical={[true, true, false]}
    >
      {productCardLoadersCount.map((_, idx) => (
        <Column key={idx} span={[12, 6, 4]}>
          <Box className={cardContainerClassName}>
            <ProductCard
              height={productCardHeight ?? '280px'}
              icon={icon}
              isLoading
            >
              <Stack orientation="vertical" spacing="space30">
                <Stack orientation="vertical" spacing="space30">
                  <SkeletonLoader height="20px" width="100px" />
                  <SkeletonLoader height="18px" width="50px" />
                </Stack>
                <Stack orientation="vertical" spacing="space30">
                  {articlesLoadersCount.map((_, idx) => (
                    <SkeletonLoader key={idx} />
                  ))}
                </Stack>
              </Stack>
            </ProductCard>
          </Box>
        </Column>
      ))}
    </Grid>
  );
};

export default ProductCardLoaders;
